import {
  DeleteTemplateParameterType,
  ViewInspectionPageParameterType,
} from "./ViewInspectionPage.type";

// ==============================|| VIEWS - PAGES - INSPECTIONSET - ACTION ||============================== //

export const GETVIEWINSPECTIONSLIST = "GETVIEWINSPECTIONSLIST";
export const DELETEVIEWINSPECTIONSTEMPLATE = "DELETEVIEWINSPECTIONSTEMPLATE";

export const getInspectonsByTemplateId = (
  getTemplateParameter: ViewInspectionPageParameterType
) => {
  return {
    type: GETVIEWINSPECTIONSLIST,
    payload: getTemplateParameter,
  };
};

export const deleteInspectonsByTemplateId = (
  deleteTemplateParameter: DeleteTemplateParameterType
) => {
  return {
    type: DELETEVIEWINSPECTIONSTEMPLATE,
    payload: deleteTemplateParameter,
  };
};
